export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2JhY2tfdG9wXzA1QV9hcmlhbF84MC5zdmciOw=="